module.exports = __webpack_public_path__ + "static/media/Assets-10-Si-Mayaa-hero.04628c87.png";